import { validate } from "com";
import { USER_ENDPOINTS } from "./endpoints";
import type { LoginUserPayload, AuthResponse } from "./types";
import { apiPost, sanitizeEmail } from "../shared";

export default async function loginUser(email: string, password: string): Promise<AuthResponse> {
  const sanitizedEmail = sanitizeEmail(email);
  validate.email(sanitizedEmail);
  validate.password(password);

  const payload: LoginUserPayload = { email: sanitizedEmail, password };
  const result = await apiPost<AuthResponse>(USER_ENDPOINTS.LOGIN, payload);

  // Do not dispatch `authChange`: `useLoginForm` calls `setAuthenticatedUser` with this response.
  // A concurrent `checkAuth()` from the listener can transiently clear auth while
  // `SmartAuthRedirect` / `resolvePostLoginRoute` is still running (Bugbot race).
  return { success: true, user: result.user };
}
